import axios from 'axios';
import HttpHelper from '../helper/HttpHelper';

class ProductService {

    getAll(payload) {
        return axios.get(HttpHelper.API_URL + '/products', { params: payload }, HttpHelper.getHeader());
    }

    getOne(id, payload) {
        return axios.get(HttpHelper.API_URL + '/products/' + id, { params: payload }, HttpHelper.getHeader());
    }

    create(payload) {
        return axios.post(HttpHelper.API_URL + '/products', payload, HttpHelper.getAuthHeader());
    }

    update(id, payload) {
        return axios.put(HttpHelper.API_URL + "/products/" + id, payload, HttpHelper.getAuthHeader());
    }

    delete(id) {
        return axios.delete(HttpHelper.API_URL + "/products/" + id, HttpHelper.getAuthHeader());
    }

}

export default ProductService = new ProductService();